module.exports = __webpack_public_path__ + "img/16-avatar male.6e312888.png";